import React, { useState, useEffect, useRef } from "react";
// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";

//************************* Libreria para realizar pdfs *************************/
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

// ------------------ COMPONENTES DE BASE--------------------------------
import Loader from "../../../../../Base/Components/Loader/Loader";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import QRCode from 'qrcode';
import JsBarcode from 'jsbarcode';


pdfMake.vfs = pdfFonts.pdfMake.vfs;

const ModalEtiquetaQR = ({
  showEtiqueta,
  selected,
  setShowEtiqueta,
  getInfo,
  setSelected,
  etiquetaQR,
  mostrarParteMedida = true,
  etiquetaPacas = false,
  proveedor = null,
  NoIngreso = null,
  Factura = null,
  FechaFactura = null,  
}) => {
  const [loading, setLoading] = useState(true);
  const [pdfUrl, setPdfUrl] = useState(null);
  const toast = useRef(null);

  const onHideReporte = () => {
    setShowEtiqueta(false);
  };

  const fmt = (val) => val ? Number(val).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ""
  
  const obtenerInformacion = (selected) => {
    setLoading(true);
    if (selected.length > 0) {
        if (etiquetaPacas) {
          GenerarEtiquetaPacas(selected);
        } else if (etiquetaQR) {
          GenerarEtiquetaQR(selected);
        }else{
          GenerarEtiquetaBarras(selected)
        }
    }
    setLoading(false);
  };
  
  const GenerarEtiquetaPacas = (registros) => {
    const codigoBarraTexto = (registro) =>
    `${FechaFactura ? new Date(FechaFactura).getFullYear().toString().slice(-2) : ""}-${String(registro?.IdPaca ?? "").padStart(4, "0")}`;
  const promesasQR = registros.map(
    (registro) =>
      new Promise((resolve, reject) => {

        const qrData = JSON.stringify({
          GinCode: registro?.GinCode ?? null,
          GinBale: registro?.GinBale ?? null,
          IdPaca: registro?.IdPaca ?? null,
        });
        QRCode.toDataURL(qrData, { errorCorrectionLevel: "M", margin: 1, width: 512 },
          (err, qrUrl) => {
            if (err) return reject(err);

            try {
              const canvas = document.createElement("canvas");
              JsBarcode(canvas, codigoBarraTexto(registro), {
                format: "CODE128",
                width: 2,
                height: 80,
                displayValue: false,
              });
              const barcodeUrl = canvas.toDataURL("image/png");
              resolve({ registro, qrUrl, barcodeUrl });
            } catch (e) {
              reject(e);
            }
          }
        );
      })
  );

  Promise.all(promesasQR).then((items) => {
    const contenido = [];
    const QR_SIZE = 220;

    items.forEach(({ registro, qrUrl, barcodeUrl  }, index) => {
      contenido.push({
        columns: [
          {
            width: QR_SIZE,
            stack: [
              { image: qrUrl, width: QR_SIZE, height: QR_SIZE },
              {
                columns: [
                  {
                    width: "65%",
                    stack: [
                      { text: `${NoIngreso ?? ""}`, style: "FilaQR", margin: [5, 0, 0, 0]},
                      { text: `${FechaFactura ? new Date(FechaFactura).getFullYear().toString().slice(-2) : ""}-${String(registro?.IdPaca ?? "").padStart(4, "0")}`, style: "FilaQR", margin: [5, 0, 0, 0] },
                    ],
                  },
                  {
                    width: "35%",
                    stack: [
                      { text: `\nLbs: ${fmt(registro?.Gross)}`, style: "QRderecha"},
                      { text: `Kgs: ${fmt(registro?.PesoNeto)}`, style: "QRderecha" },
                    ],
                  },
                ],
                columnGap: 0,
                margin: [0, 2, 0, 0],
              },
            ],
          },
          {
            width: "*",
            margin: [0, 0, 0, 0],
            stack: [
              {
                stack: [
                  { text: `${FechaFactura ? new Date(FechaFactura).getFullYear().toString().slice(-2) : ""}-${String(registro?.IdPaca ?? "").padStart(4, "0")}`, style: "Titulo" },
                ],
                margin: [0, 0, 0, 0],
              },
              {
                canvas: [
                  {
                    type: "line",
                    x1: 0, y1: 0,
                    x2: 176, y2: 0,
                    lineWidth: 0.5,
                    lineColor: "#000000",
                  },
                ],
                margin: [0, 0, 0, 0],
              },
              {
                stack: [
                  { text: "GIN BALE", style: "Gin" },
                  { text: `${registro?.GinBale ?? ""}`, style: "Titulo" },
                ],
                margin: [0, 0, 0, 0],
              },
              {
                columns: [
                  {
                    width: "*",
                    stack: [
                      { text: `Gin Code: ${registro?.GinCode ?? ""}`, style: "Gin" },
                    ],
                  },
                  
                ],
                margin: [0, 0, 0, 0],
              },
              {
                columns: [
                  {
                    width: "auto",
                    stack: [
                      { text: `Grado ${registro?.Grd ?? ""}`, style: "Fila" },
                    ],
                  },
                  {
                    width: "auto",
                    stack: [
                      { text: `Unif. ${registro?.Mic ?? ""}`, style: "Fila" },
                    ],
                  },
                  {
                    width: "auto",
                    stack: [
                      { text: `Trash ${registro?.Trsh ?? ""}`, style: "Fila" },
                    ],
                  },
                ],
                columnGap: 5,
                margin: [0, 2, 0, 0],
              },
              {
                canvas: [
                  {
                    type: "line",
                    x1: 0, y1: 0,
                    x2: 176, y2: 0,
                    lineWidth: 0.5,
                    lineColor: "#000000",
                  },
                ],
                margin: [0, 0, 0, 0],
              },
              {
                columns: [
                  {
                    width: "*",
                    stack: [
                      { text: `Factura: ${Factura ?? ""}`, style: "Fila" },
                      { text: `Proveedor: ${proveedor ?? ""}`, style: "Fila" },
                      { image: barcodeUrl, width: QR_SIZE, width: 180, height: 70, margin: [0, 0, 0, 0] },
                    ],
                  },
                ],
                margin: [0, 2, 0, 0],
              },
            ],
          },
        ],
        columnGap: 8,
      });

      if (index < items.length - 1) {
        contenido.push({ text: "", pageBreak: "after" });
      }
    });

    const docDefinition = {
      pageSize: { width: 432, height: 288 },
      pageMargins: [15, 10, 15, 10],
      content: contenido,
      styles: {
        Gin: {
          fontSize: 17,
          bold: true,
          color: "#000000",
          alignment: "center",
        },
        Titulo: {
          fontSize: 35,
          bold: true,
          alignment: "center",
          color: "#000000",
        },
        valorCampo: {
          fontSize: 15,
          bold: true,
          alignment: "left",
          color: "#000000",
        },
        QRderecha: {
          fontSize: 10,
          bold: true,
          alignment: "right",
          color: "#000000",
        },
        Fila:{
          fontSize: 13,
          bold: true,
          alignment: "left",
          color: "#000000",
        },
        FilaQR:{
          fontSize: 17,
          bold: true,
          alignment: "left",
          color: "#000000",
        }
      },
      defaultStyle: { font: "Roboto" },
    };

    const doc = pdfMake.createPdf(docDefinition);
    doc.getDataUrl((url) => setPdfUrl(url));
  });
};

  const GenerarEtiquetaQR = (productosTempo) => {

    const contenido = [];

    productosTempo.forEach((producto, index) => {
      let CodigoQR =
      console.log(QRCode);
      QRCode.toDataURL(`${producto?.CodigoProducto}`, { errorCorrectionLevel: 'Q' }, (err, url) => {
        console.log(url, err);
        CodigoQR = url;
      })

      contenido.push({
        columns: [
          {
            margin: [0, 0, 0, 0],
            table: {
              widths: ["*"],
              body: [
                [
                  {
                    image: CodigoQR,
                    width: 78,
                    height: 78,
                    margin: [-20, -5, 0, 0],
                  },
                ],
              ],
            },
            layout: {
              defaultBorder: false,
            }
          },

          // {
          //   text: [
          //     { text: `${producto?.CodigoProducto}\n`, style: "titulo1" },
          //     { text: "      "},
          //     { text: `${producto?.NombreProducto}\n`, style: "infoGeneral" },
          //     { text: "      "},
          //     { text: `${producto?.NombreCategoria}\n`, style: "infoGeneral2"},

          //   ],
          //   margin: [-38, 5, -7, 0],
          // },

          {
            margin: [-38, 5, -7, 0],  
            table: {
              widths: ["*"], 
              body: [
                [
                  {
                    text: `${producto?.CodigoProducto}`,
                    style: "titulo1",
                    alignment: "center", 
                  },
                ],
                [
                  {
                    text: `${producto?.NombreProducto?.substring(0, 60) || ''}`,
                    // text: `${producto?.NombreProducto || ''}`,
                    style: "infoGeneral",
                  },
                ],
                [
                  {
                    text: `- ${producto?.NombreCategoria} -`,
                    style: "infoGeneral2",
                    margin: [0, 2, 0, 0]
                  },
                ],
                [
                  {
                    text: `Parte: ${producto?.NoParte || ''}   Medida: ${producto?.Medida || ''}`,
                    style: "infoGeneral2",
                    margin: [0, 0, 0, 0],
                  },
                ],
              ],
            },
            layout: 'noBorders', 
          },

        ],
      },
      index < productosTempo.length - 1 ? { text: '', pageBreak: 'after' } : null
    );
    })


    const docDefinition = {
      pageSize: {
        width: 210,
        height: 72,
      },

      pageMargins: [10, 0, 10, 0],
      content: contenido,
      styles: {
        titulo1: {
          fontSize: 10.5,
          bold: true,
          alignment: "center",
        },
        infoGeneral: {
          fontSize: 8,
          bold: true,
          alignment: "center",
        },
        infoGeneral2: {
          fontSize: 7,
          alignment: "center",
        },
      },
    };

    const doc = pdfMake.createPdf(docDefinition);
    
    doc.getDataUrl((url) => {
      setPdfUrl(url); 
    });

    // const doc = pdfMake.createPdf(docDefinition);

    // doc.getDataUrl((url) => {
    //   setPdfUrl(url);
    // });
  };

  const GenerarEtiquetaBarras = (productosTempo) => {

    const contenido = [];

    productosTempo.forEach((producto, index) => {
        const canvas = document.createElement('canvas');
        JsBarcode(canvas, producto.CodigoProducto, {
          format: 'CODE128',
          width: 2,
          height: 80,
          displayValue: false,
        });
    
        const codigoBarrasURL = canvas.toDataURL('image/png');      
  
        contenido.push({
          stack: [
            {
              table: {
                widths: ["50%", "50%"],
                body: [
                  [
                    {
                      stack: [
                        {
                          image: codigoBarrasURL,
                          width: 105,
                          height: 42,
                          alignment: "center",
                          margin: [0, 3, 0, 0],
                        },
                        {
                          text: `${producto?.CodigoProducto || ""}`,
                          style: "titulo",
                          margin: [0, 1, 0, 0],
                        },
                      ],
                    },
                    {
                      stack: [
                        {
                          text: `${producto?.NombreProducto?.substring(0, 45) || ""}`,
                          style: "infoGeneral",
                        },
                        {
                          text: `${producto?.NombreCategoria || ""}`,
                          style: "infoGeneral2",
                        },
                        ...(mostrarParteMedida
                          ? [
                              {
                                text: `${producto?.NoParte || producto?.Parte || ""}`,
                                style: "infoGeneral2",
                              },
                              {
                                text: `${producto?.Medida || ""}`,
                                style: "infoGeneral2",
                              },
                            ]
                          : []),
                      ],
                      margin: [0, 6, 0, 0],
                    },
                  ],
                ],
              },
              layout: "noBorders",
            },

            index < productosTempo.length - 1
              ? { text: "", pageBreak: "after" }
              : null,
          ],
        });
    });
    
    const docDefinition = {
    pageSize: {
        width: 210,
        height: 72,
    },
    pageMargins: [10, 0, 10, 0],
    content: contenido,
    styles: {
        titulo: {
        fontSize: 10.5,
        bold: true,
        alignment: "center",
        },
        infoGeneral: {
        fontSize: 9.2,
        bold: true,
        alignment: "center",
        margin: [0, 1, 0, 3]
        },
        infoGeneral2: {
        fontSize: 8.5,
        alignment: "center",
        margin: [0, 1, 0, 3]
        },
    },
    };

    const doc = pdfMake.createPdf(docDefinition);
    
    doc.getDataUrl((url) => {
      setPdfUrl(url); 
    });

    // const doc = pdfMake.createPdf(docDefinition);

    // doc.getDataUrl((url) => {
    //   setPdfUrl(url);
    // });
  };

  useEffect(() => {
    if (showEtiqueta) {
      obtenerInformacion(selected);
    }
  }, [showEtiqueta]);

  return (
    <Dialog
      visible={showEtiqueta}
      onHide={onHideReporte}
    >
      <h4 className="mx-2">{etiquetaQR ? "Código QR" : "Código de Barras"}</h4>
      <Loader loading={loading} querySelector={"#Modal"} />
      <Toast ref={toast} />
      <div id="Modal">
        {!loading && pdfUrl && (
          <iframe
            src={pdfUrl}
            style={{ width: "60vw", height: "75vh", border: "1px solid #ccc" }}
            id="foo"
            title="Reporte QR PDF"
          />
        )}
      </div>
    </Dialog>
  );
};

export default ModalEtiquetaQR;
